/**
 * Validation for the free-text names a parent edits in Settings — their own
 * Name (Profile, YAR-142) and the Household name (YAR-145).
 *
 * Both fields could be cleared and saved, leaving an empty name everywhere it
 * is shown. Rules (QA's proposed ACs on both stories):
 *   - required: empty or whitespace-only is invalid;
 *   - leading / trailing spaces are trimmed before saving.
 *
 * No maximum length: product (@kelvin, YAR-142 / YAR-145, Oct 12) does not
 * want one. The database enforces the same two rules on every edit
 * (migrations `settings_name_validation` and `settings_name_no_max_length`).
 */

/** The value that gets saved. */
export function normalizeName(value: string): string {
  return value.trim();
}

/**
 * The inline error for a name, or null when it can be saved.
 * `label` is the field's name as the parent reads it ("Name", "Household name").
 */
export function nameError(value: string, label: string): string | null {
  const name = normalizeName(value);
  if (!name) return `${label} is required`;
  return null;
}
